var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.examineInfo.config == 0
        ? _c(
            "el-form",
            {
              ref: "form",
              staticClass: "crm-create-box",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-position": "top",
              },
            },
            [
              _c(
                "el-form-item",
                { staticClass: "crm-create-item", attrs: { prop: "name" } },
                [
                  _c(
                    "div",
                    {
                      staticStyle: { display: "inline-block" },
                      attrs: { slot: "label" },
                      slot: "label",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            margin: "5px 0",
                            "font-size": "12px",
                            "word-wrap": "break-word",
                            "word-break": "break-all",
                          },
                        },
                        [
                          _vm._v("\n          审核人\n          "),
                          _c("span", { staticStyle: { color: "#999" } }),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("xh-user-cell", {
                    attrs: {
                      "info-type": _vm.types,
                      value: _vm.draftUser ? [_vm.draftUser] : [],
                    },
                    on: { "value-change": _vm.fieldValueChange },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm.examineInfo.config == 1
        ? _c(
            "flexbox",
            { staticClass: "fixed-examine", attrs: { wrap: "wrap" } },
            _vm._l(_vm.examineInfo.stepList, function (item, index) {
              return _c(
                "el-popover",
                {
                  key: index,
                  attrs: {
                    disabled: item.user_id_info.length == 0,
                    content: _vm._f("contentFilters")(item.user_id_info),
                    placement: "bottom",
                    trigger: "hover",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "fixed-examine-item",
                      attrs: { slot: "reference" },
                      slot: "reference",
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: require("@/assets/img/examine_head.png"),
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "detail" }, [
                        _vm._v(_vm._s(_vm._f("detail")(item))),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "step" }, [
                        _vm._v(_vm._s(_vm._f("step")(index + 1))),
                      ]),
                    ]
                  ),
                ]
              )
            }),
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }